<template>
  <div class="login-wrap">
    <header class="flex-center header-warpper">
      <div class="flex-center contaner">
        <div class="flex-center logo-box">
          <div class="flex-center logo-box_img">
            <img src="@/assets/images/home/FASTPAY.png" style="width: 290px; height: 100px" />
          </div>
        </div>
        <div class="flex-center right-menu">
          <!-- <div class="assist-text">{{$t('login.rules.form.assist')}}</div> -->
          <select-lang />
        </div>
      </div>
    </header>
    <div class="contaner tent-contaner">
      <div class="label">{{ $t('login.rules.form.fast_lable') }}</div>
      <el-form
        class="login-form"
        label-position="top"
        label-width="80px"
        :model="formdata"
        :rules="rules"
        ref="form"
      >
        <div style="margin-bottom: 5%">
          <div class="loginTitle">{{ $t('login.rules.form.Login') }}</div>

          <el-form-item prop="username">
            <label>{{ $t('login.rules.form.accountName') }}</label>
            <el-input
              v-model.trim="formdata.username"
              :placeholder="$t('login.rules.form.UserName')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <label>{{ $t('login.rules.form.password_fast') }}</label>
            <el-input
              v-model.trim="formdata.password"
              show-password
              :placeholder="$t('login.rules.form.Password')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <label>{{ $t('login.rules.form.GoogleCode') }}</label>
            <el-input
              v-model.trim="formdata.code"
              :placeholder="$t('login.rules.form.verification')"
            ></el-input>
          </el-form-item>
          <!--<img :src="captchaImg" alt="" @click="changeed()" style="margin-left: 45%" />-->
        </div>
        <el-button @click="handleLogin()" class="login-btn">{{
          $t('login.rules.form.btnlogin')
        }}</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import selectLang from '@/components/cuscom/select-lang/lang-fastpay.vue';
import { checkPass } from '@/utils/validate';
export default {
  components: { selectLang },
  data() {
    return {
      loading: false,
      formdata: {
        username: '',
        password: '',
        code: ''
      },
      captchaImg: '' //图片路径
    };
  },

  created() {
    if (process.env.NODE_ENV === 'development') {
      this.formdata.username = 'testzat';
      this.formdata.password = '123456';
    }
    // this.Render();
    this.rules = {
      username: [
        {
          required: true,
          message: this.$t('login.rules.username'),
          trigger: 'blur'
        }
      ],
      code: [
        {
          required: true,
          message: this.$t('login.rules.code'),
          trigger: 'blur'
        }
      ],
      password: [
        {
          required: true,
          message: this.$t('login.rules.password'),
          trigger: 'blur'
        },
        {
          validator: (rule, value, cb) => {
            if (!checkPass(value)) {
              cb(new Error(this.$t('passwd.rules.newPasswd.format')));
            } else {
              cb();
            }
          },
          trigger: 'blur'
        }
      ]
    };
  },
  mounted() {
    this.init();
  },
  destroyed() {
    document.removeEventListener('keyup', (e) => {
      if (e && e.keyCode == 13) {
        this.handleLogin();
      }
    });
  },
  methods: {
    init() {
      document.addEventListener('keyup', (e) => {
        if (e && e.keyCode == 13) {
          this.handleLogin();
        }
      });
    },
    // 获取验证码
    async Render() {
      this.loading = true;
      let res = await this.$http.get('/token/render', {
        responseType: 'blob'
      });
      console.log(res);
      this.loading = false;
      this.captchaImg = window.URL.createObjectURL(res.data);
    },
    // 切换验证码
    changeed() {
      this.Render();
    },
    loginSuccess(res) {
      this.$message.success(res.msg);
      this.$router.push({
        // name: 'home'
        path: res.data.menuTree[0].menuUrl
      });
    },
    async handleLogin() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const params = {
            kaptchaCode: this.formdata.code,
            password: this.formdata.password,
            userName: this.formdata.username
          };
          const data = await this.$store.dispatch('handleLogin', params);
          if (data.code === 200) {
            this.loginSuccess(data);
          } else {
            // //刷新验证码
            // this.Render();
            this.formdata.code = '';
            this.$message.error(data.msg || 'Network error!');
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-wrap {
  height: 100vh;
  background: url('../../assets/images/home/logo-fastpay-bg.jpg') no-repeat center/cover;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .header-warpper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 88px;

    .contaner {
      width: 100%;
      height: 100%;
      justify-content: space-between;
      padding: 0 135px;
      box-sizing: border-box;

      .right-menu {
        .assist-text {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 48px;
          margin-right: 30px;
          border: 1.4px solid #c4bbad;
          border-radius: 4px;
          padding: 12px 32px;
          color: #ddd8cf;
          font-size: 24px;
          box-sizing: border-box;
        }
      }
    }
  }
  .tent-contaner {
    display: flex;
    position: absolute;
    right: 135px;
    top: 168px;
  }
  .label {
    max-width: 731px;
    color: #fff;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    font-family: FZBeiWeiKaiShu-S19S;
    font-size: 56px;
    font-style: normal;
    font-weight: 400;
    line-height: 80px;
    letter-spacing: 3px;
    flex: 1;
    margin-right: 100px;
    position: fixed;
    left: 135px;
  }
}
.flex-center {
  display: flex;
  align-items: center;
}
.login-wrap .login-form {
  width: 470px;
  border-radius: 5px;
  padding: 32px;
  box-sizing: border-box;
  color: #eeece6;
  border: 2px solid #9b8874;
  background: #eeece63d;
}

.login-wrap .login-btn {
  width: 100%;
  color: #2a2320;
  border: none;
  border-radius: 0px;
  height: 56px;
  margin-top: 16px;
  background: linear-gradient(90deg, #c8bcab 0%, #b7a088 100%);
  font-size: 28px;
  border-radius: 4px;
  margin-bottom: 48px;
}
.loginTitle {
  text-align: center;
  font-size: 32px;
  font-weight: 400;
  margin-bottom: 32px;
}

/deep/ .el-input__prefix {
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-input--prefix .el-input__inner {
  padding-left: 64px;
}
/deep/ .icon-user,
/deep/ .icon-more-outline,
/deep/ .icon-chat-dot-round {
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-input__icon {
  width: 45px;
  height: 56px;
}
/deep/ .icon-user {
  background: url('./../../assets/images/home/user.png') no-repeat center;
  background-size: 50px 50px;
}
/deep/ .icon-more-outline {
  background: url('./../../assets/images/home/password.png') no-repeat center;
  background-size: 50px 50px;
}
/deep/ .icon-chat-dot-round {
  background: url('./../../assets/images/home/code.png') no-repeat center;
  background-size: 50px 50px;
}
/deep/ .el-input__inner {
  border: none;
  border-bottom: 1px solid #c4bbad;
  height: 44px;
  line-height: 44px;
  background-color: transparent;
  border-radius: 0;
  padding: 0;
  color: #eeece6;
  font-size: 28px;
}
/deep/ .el-input__inner::placeholder {
  /* Chrome/Opera/Safari */
  font-family: FZBeiWeiKaiShu-S19S;
}
/deep/ .el-input__clear {
  font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login-fastpay.vue